/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

function FormDiscount({ parent, edit }) {
  const [attr, setAttr] = useState(parent);
  const [focus, setFocus] = useState(false);
  const [discountChange, setDiscountChange] = useState(parent.discount_value);

  const send = () => {
    if (attr.discount_value !== discountChange) {
      setDiscountChange(attr.discount_value);
      edit(
        { id: attr.id, discount_value: attr.discount_value, discount_type: attr.discount_type },
        'DISCOUNT'
      );
    }
  };

  const sendType = (type) => {
    setAttr({ ...attr, discount_type: type });
    edit({ id: attr.id, discount_value: attr.discount_value, discount_type: type }, 'DISCOUNT');
  };

  return (
    <MDBox
      noValidate
      component='form'
      role='form'
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
    >
      <MDInput
        value={attr.discount_value}
        type='number'
        onChange={(e) => setAttr({ ...attr, discount_value: e.target.value })}
        onFocus={(e) => {
          setFocus(true);
          e.target.select();
        }}
        onBlur={() => {
          if (focus) {
            setFocus(false);
            send();
          }
        }}
        variant='standard'
        fullWidth
        InputProps={{
          inputProps: {
            maxLength: 20,
            autoComplete: 'off',
            className: 'text-right',
            sx: { minWidth: 80 },
          },
          endAdornment:
            attr.discount_type === 'P' ? (
              <IconButton onClick={() => sendType('B')} color='info' sx={{ p: 0 }}>
                <Icon>percent</Icon>
              </IconButton>
            ) : (
              <IconButton onClick={() => sendType('P')} color='primary' sx={{ p: 0 }}>
                <Icon>currency_bitcoin</Icon>
              </IconButton>
            ),
        }}
      />
    </MDBox>
  );
}

FormDiscount.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    discount_value: PropTypes.string.isRequired,
    discount_type: PropTypes.string.isRequired,
  }).isRequired,
  edit: PropTypes.func.isRequired,
};

export default FormDiscount;
